import * as UserProfileModule from "./index";

const USER_DASHBOARD_PREFIX = "/dashboard/";

export const User_Settings = {
  path: `${USER_DASHBOARD_PREFIX}settings`,
  name: "UserSettings",
  component: UserProfileModule.UserSettings,
};

export const User_SetSecurityQuestion = {
  path: `${USER_DASHBOARD_PREFIX}set-security-question`,
  name: "UserSetSecurityQuestion",
  component: UserProfileModule.SetSecurityQuestion,
};

export const User_UpdateUser = {
  path: `${USER_DASHBOARD_PREFIX}update-user`,
  name: "UpdateUser",
  component: UserProfileModule.UpdateUser,
};

export const User_UpdateUserSecurityData = {
  path: `${USER_DASHBOARD_PREFIX}update-user-security-data`,
  name: "UpdateUserSecurityData",
  component: UserProfileModule.UpdateUserSecurityData,
};

export const User_UserSkills = {
  path: `${USER_DASHBOARD_PREFIX}user-skills`,
  name: "UserSkills",
  component: UserProfileModule.UserSkills,
};
